import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';
import { formatCurrency } from 'utils/fuctions/formatCurrency';

const ModalOpportunityInfo = ({ opportunity, openAutomatically = false }) => {
  const [modalIsOpen, setModalIsOpen] = useState(openAutomatically);

  useEffect(() => {
    if (openAutomatically) {
      setModalIsOpen(true);
    }
  }, [openAutomatically]);

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const dateCreate = opportunity?.createdAt
    ? toBrazilianFullDate(opportunity.createdAt)
    : '';

  const lastUpdate = opportunity?.lastUpdatedAt
    ? toBrazilianFullDate(opportunity.lastUpdatedAt)
    : '';

  const firstContactDate = opportunity?.firstContactDate
    ? toBrazilianFullDate(opportunity.firstContactDate)
    : '';

  const associationDate = opportunity?.associationDate
    ? toBrazilianFullDate(opportunity.associationDate)
    : '';

  return (
    <>
      <Button
        color="info"
        size="sm"
        title="Ver Informações"
        onClick={toggleModal}
        className="ml-1"
      >
        <i className="fas fa-info-circle"></i>
      </Button>

      <Modal isOpen={modalIsOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          Informações da Oportunidade
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <p>
                <strong>Título: </strong>
                {opportunity?.title || opportunity?.name || '-'}
              </p>
              <p>
                <strong>Fase: </strong>
                {opportunity?.opportunityStage?.name ||
                  opportunity?.stageName ||
                  '-'}
              </p>
              <p>
                <strong>Valor: </strong>
                {opportunity?.amount
                  ? formatCurrency(opportunity.amount, false)
                  : 'R$ 0,00'}
              </p>
              <p>
                <strong>Responsável: </strong>
                {opportunity?.responsibleName || '-'}
              </p>
              <p>
                <strong>Criado por: </strong>
                {opportunity?.createdByName || '-'}
              </p>
              <p>
                <strong>Data de criação: </strong>
                {dateCreate}
              </p>
              <p>
                <strong>Última atualização: </strong>
                {lastUpdate}
              </p>
            </div>
            <div className="col-md-6">
              <p>
                <strong>Conta: </strong>
                {opportunity?.accountName || '-'}
              </p>
              <p>
                <strong>Contato: </strong>
                {opportunity?.contactName || '-'}
              </p>
              <p>
                <strong>Origem da Interação: </strong>
                {opportunity?.channelOrigin || '-'}
              </p>
              <p>
                <strong>Data do Primeiro Contato: </strong>
                {firstContactDate}
              </p>
              <p>
                <strong>Gerada via Lead: </strong>
                {opportunity?.isConverted ? 'Sim' : 'Não'}
              </p>
              <p>
                <strong>Gerada Manualmente: </strong>
                {opportunity?.isManual ? 'Sim' : 'Não'}
              </p>
              <p>
                <strong>Operador que Associou: </strong>
                {opportunity?.associatedBy || '-'}
              </p>
              <p>
                <strong>Data de Associação: </strong>
                {associationDate}
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalOpportunityInfo;
